document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.reviews-section-wrapper');

  wrappers.forEach((wrapper) => {
    const track = wrapper.querySelector('.reviews-carousel-track');
    const tabsContainer = wrapper.querySelector('.reviews-tabs');
    const tabs = Array.from(wrapper.querySelectorAll('.review-tab-btn'));
    const dots = Array.from(wrapper.querySelectorAll('.dot'));
    const btnPrev = wrapper.querySelector('.btn-prev');
    const btnNext = wrapper.querySelector('.btn-next');

    if (!(track instanceof HTMLElement) || !(tabsContainer instanceof HTMLElement)) return;
    const slides = Array.from(wrapper.querySelectorAll('.carousel-slide'));

    if (slides.length === 0) return;

    let isInternalScroll = false;
    /** @type {ReturnType<typeof setTimeout> | null} */
    let scrollTimeout = null;
    let activeIndex = -1;
    const firstTab = tabs[0];
    let activeTabKey = firstTab ? firstTab.getAttribute('data-tab-key') || '' : '';

    /** Slide indexes (into `slides`) that belong to the active tab. Untagged slides show in every tab. */
    let visibleIndexes = slides.map((_, i) => i);

    /**
     * @param {Element} slide
     */
    const belongsToActiveTab = (slide) => {
      const slideKey = slide.getAttribute('data-tab-key') || '';
      return !activeTabKey || !slideKey || slideKey === activeTabKey;
    };

    const applyTabFilter = () => {
      visibleIndexes = [];
      let dotNumber = 0;

      slides.forEach((slide, i) => {
        const isVisible = belongsToActiveTab(slide);
        if (slide instanceof HTMLElement) slide.hidden = !isVisible;

        const dot = dots[i];
        if (dot instanceof HTMLElement) {
          dot.hidden = !isVisible;
          if (isVisible) {
            dotNumber += 1;
            dot.setAttribute('aria-label', `Go to slide ${dotNumber}`);
          }
        }

        if (isVisible) visibleIndexes.push(i);
      });

      tabs.forEach((tab) => {
        const isActive = (tab.getAttribute('data-tab-key') || '') === activeTabKey;
        tab.classList.toggle('active', isActive);
        tab.setAttribute('aria-selected', isActive.toString());

        if (isActive && tab instanceof HTMLElement) {
          tabsContainer.scrollTo({
            left: tab.offsetLeft - tabsContainer.offsetWidth / 2 + tab.offsetWidth / 2,
            behavior: 'smooth',
          });
        }
      });

      activeIndex = -1;
    };

    /**
     * @param {number} index Slide index (into `slides`)
     */
    const updateUI = (index) => {
      if (activeIndex === index) return;
      activeIndex = index;

      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    };

    /**
     * @param {number} index Slide index (into `slides`)
     * @param {ScrollBehavior} [behavior]
     */
    const scrollToSlide = (index, behavior = 'smooth') => {
      if (!visibleIndexes.includes(index)) return;

      const targetSlide = slides[index];
      if (!(targetSlide instanceof HTMLElement)) return;

      isInternalScroll = true;
      if (scrollTimeout) clearTimeout(scrollTimeout);

      const scrollPos =
        targetSlide.offsetLeft -
        (track.offsetWidth / 2) +
        (targetSlide.offsetWidth / 2);

      track.scrollTo({
        left: scrollPos,
        behavior,
      });

      updateUI(index);

      const handleScrollEnd = () => {
        track.removeEventListener('scrollend', handleScrollEnd);
        isInternalScroll = false;
      };

      if (behavior === 'smooth' && 'onscrollend' in window) {
        track.addEventListener('scrollend', handleScrollEnd);
      } else {
        scrollTimeout = setTimeout(() => {
          isInternalScroll = false;
        }, 250);
      }
    };

    /**
     * @param {string} tabKey
     */
    const selectTab = (tabKey) => {
      activeTabKey = tabKey;
      applyTabFilter();
      if (visibleIndexes.length > 0) scrollToSlide(visibleIndexes[0], 'auto');
    };

    /**
     * @param {number} step +1 for next, -1 for previous
     */
    const moveBy = (step) => {
      if (visibleIndexes.length === 0) return;

      const currentPos = Math.max(visibleIndexes.indexOf(activeIndex), 0);
      const nextPos = (currentPos + step + visibleIndexes.length) % visibleIndexes.length;
      scrollToSlide(visibleIndexes[nextPos]);
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        const currentTarget = e.currentTarget;
        if (!(currentTarget instanceof HTMLElement)) return;

        const tabKey = currentTarget.getAttribute('data-tab-key') || '';
        if (tabKey === activeTabKey) return;
        selectTab(tabKey);
      });
    });

    if (btnNext) btnNext.addEventListener('click', () => moveBy(1));
    if (btnPrev) btnPrev.addEventListener('click', () => moveBy(-1));

    dots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        const currentTarget = e.currentTarget;
        if (!(currentTarget instanceof HTMLElement)) return;

        const targetIdxStr = currentTarget.getAttribute('data-index');
        const targetIdx = parseInt(targetIdxStr || '0', 10);
        scrollToSlide(targetIdx);
      });
    });

    /** @type {ReturnType<typeof setTimeout> | null} */
    let scrollDebounce = null;
    track.addEventListener(
      'scroll',
      () => {
        if (isInternalScroll) return;

        if (scrollDebounce) clearTimeout(scrollDebounce);
        scrollDebounce = setTimeout(() => {
          let closestIndex = visibleIndexes[0] ?? 0;
          let minDiff = Infinity;
          const trackCenter = track.scrollLeft + track.offsetWidth / 2;

          visibleIndexes.forEach((i) => {
            const slide = slides[i];
            if (!(slide instanceof HTMLElement)) return;

            const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
            const diff = Math.abs(trackCenter - slideCenter);
            if (diff < minDiff) {
              minDiff = diff;
              closestIndex = i;
            }
          });

          updateUI(closestIndex);
        }, 15);
      },
      { passive: true }
    );

    // Theme editor: selecting a card that lives under another tab switches to that tab
    document.addEventListener('shopify:block:select', (event) => {
      const target = event.target;
      if (!(target instanceof Element) || !wrapper.contains(target)) return;

      const slide = target.closest('.carousel-slide');
      if (!slide) return;

      const slideKey = slide.getAttribute('data-tab-key') || '';
      if (slideKey && slideKey !== activeTabKey) selectTab(slideKey);
      scrollToSlide(slides.indexOf(slide));
    });

    applyTabFilter();
    if (visibleIndexes.length > 0) updateUI(visibleIndexes[0]);
  });
});
